import appCommunication from '@/services/app-communication'
import typeCheckerUtils from '@/utils/type-checker'
import * as issueTypes from '@/types/issue'

export default {
  issues: [
    {
      type: 'general',
      category: 'driver',
      subCategory: 'update-documents',
      code: 'update-personal-documents',
      title: 'updatePersonalDocumentsTitle',
      description: 'updatePersonalDocumentsText',
      fields: [
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: false
        }
      ],
      photos: [
        { key: 'idPhoto', file: null, uploaded: false, isRequired: true },
        { key: 'personalPhoto', file: null, uploaded: false, isRequired: false },
        { key: 'licensePhoto', file: null, uploaded: false, isRequired: false }
      ]
    },
    {
      type: 'general',
      category: 'driver',
      subCategory: 'update-documents',
      code: 'update-vehicle-documents',
      title: 'updateVehicleDocumentsTitle',
      description: 'updateVehicleDocumentsText',
      fields: [
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: false
        }
      ],
      photos: [
        { key: 'registrationPhoto', file: null, uploaded: false, isRequired: true },
        { key: 'vehiclePhoto', file: null, uploaded: false, isRequired: true },
        { key: 'delegationPhoto', file: null, uploaded: false, isRequired: false },
        { key: 'insurancePhoto', file: null, uploaded: false, isRequired: false }
      ]
    },
    {
      type: 'general',
      category: 'driver',
      subCategory: 'change-account-settings',
      code: 'want-to-delete-account',
      title: 'driverDeleteAccountTitle',
      description: 'driverDeleteAccountText',
      fields: [
        {
          key: 'additionalInfoDeleteAccount',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: true
        }
      ],
      photos: []
    },
    {
      type: 'general',
      category: 'driver',
      subCategory: 'other',
      code: 'have-different-question-about-ego',
      title: 'questionOtherTitle',
      description: 'questionOtherText',
      fields: [
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: true
        }
      ],
      photos: [{ key: 'photo', file: null, uploaded: false, isRequired: false }]
    },
    {
      type: 'general',
      category: 'driver',
      subCategory: 'getting-paid',
      code: 'draw-earnings',
      title: 'drawEarningsTitle',
      description: 'drawEarningsText',
      warning: 'drawEarningsWarning',
      fields: [
        {
          key: 'idNumber',
          label: 'ID Number',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'stcPayPhoneNumber',
          label: 'Stc Pay Phone Number',
          type: 'text',
          value: '',
          required: true
        }
      ],
      photos: []
    },
    {
      type: 'ride',
      category: 'driver',
      subCategory: 'issues-with-my-fare',
      code: 'should-have-received-a-cancellation-fee',
      title: 'cancellationFeeMissingTitle',
      description: 'cancellationFeeMissingText',
      fields: [
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: true
        }
      ],
      photos: []
    },
    {
      type: 'ride',
      category: 'driver',
      subCategory: 'issues-with-my-fare',
      code: 'didnt-collect-the-right-amount-of-cash',
      title: 'cashNotRightTitle',
      description: 'cashNotRightText',
      fields: [
        {
          key: 'cashCollected',
          label: 'Cash Collected From Rider',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: false
        }
      ],
      photos: []
    },
    {
      type: 'ride',
      category: 'driver',
      subCategory: 'issues-with-my-fare',
      code: 'my-fare-was-adjusted',
      title: 'fareAdjustedTitle',
      description: 'fareAdjustedText',
      fields: [
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: true
        }
      ],
      photos: []
    },
    {
      type: 'ride',
      category: 'driver',
      subCategory: 'issue-with-rider',
      code: 'was-involved-in-accident',
      title: 'driverAccidentTitle',
      description: 'driverAccidentText',
      fields: [
        {
          key: 'dateOfAccident',
          label: 'Date Of Accident',
          type: 'date',
          value: '',
          required: true
        },
        {
          key: 'timeOfAccident',
          label: 'Time Of Accident',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'locationOfAccident',
          label: 'Location Of Accident',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'inVehicle',
          label: 'Were You In The Vehicle',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'isInjured',
          label: 'Were You Injured',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'isDamaged',
          label: 'Were Your Vehicle Damaged',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: false
        }
      ],
      photos: [
        { key: 'accidentPhoto', file: null, uploaded: false, isRequired: true },
        { key: 'policeReport', file: null, uploaded: false, isRequired: true }
      ]
    },
    {
      type: 'ride',
      category: 'driver',
      subCategory: 'found-item',
      code: 'found-item',
      title: 'foundItemTitle',
      description: 'foundItemText',
      fields: [
        {
          key: 'foundItemTime',
          label: 'When Did You Find The Item',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'foundItemRide',
          label: 'Do You Know Which Ride This Item Belongs To',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'phoneShare',
          label: 'Do You Want To Share Your Numbe With The Rider',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: false
        }
      ],
      photos: [{ key: 'itemPhoto', file: null, uploaded: false, isRequired: true }]
    },
    {
      type: 'general',
      category: 'client',
      subCategory: 'change-account-settings',
      code: 'want-to-delete-account',
      title: 'clientDeleteAccountTitle',
      description: 'clientDeleteAccountText',
      fields: [
        {
          key: 'additionalInfoDeleteAccount',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: true
        }
      ],
      photos: []
    },
    {
      type: 'general',
      category: 'client',
      subCategory: 'payment-options',
      code: 'have-another-payment-question',
      title: 'clientPaymentOtherTitle',
      description: 'clientPaymentOtherText',
      fields: [
        {
          key: 'yourInquiry',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: true
        }
      ],
      photos: [{ key: 'photo', file: null, uploaded: false, isRequired: false }]
    },
    {
      type: 'general',
      category: 'client',
      subCategory: 'payment-options',
      code: 'duplicate-charge',
      title: 'duplicateChargeTitle',
      description: 'duplicateChargeText',
      fields: [
        {
          key: 'amount',
          label: 'Amount',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'firstCharge',
          label: 'Date Of First Charge',
          type: 'date',
          value: '',
          required: true
        },
        {
          key: 'secondCharge',
          label: 'Date Of Second Charge',
          type: 'date',
          value: '',
          required: true
        },
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: false
        }
      ],
      photos: []
    },
    {
      type: 'general',
      category: 'client',
      subCategory: 'payment-options',
      code: 'refund-request',
      title: 'refundRequestTitle',
      description: 'refundRequestText',
      warning: 'refundRequestWarning',
      fields: [
        {
          key: 'idNumber',
          label: 'ID Number',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'stcPayPhoneNumber',
          label: 'Stc Pay Phone Number',
          type: 'text',
          value: '',
          required: true
        }
      ],
      photos: []
    },
    {
      type: 'ride',
      category: 'client',
      subCategory: 'would-like-refund',
      code: 'was-charged-cancellation-fee',
      title: 'clientCancellationFeeTitle',
      description: 'clientCancellationFeeText',
      fields: [
        {
          key: 'chooseOneOfOptions',
          label: 'Reason',
          type: 'select',
          options: [
            'cancellationFeeOption1',
            'cancellationFeeOption2',
            'cancellationFeeOption3',
            'cancellationFeeOption4',
            'cancellationFeeOption5',
            'cancellationFeeOption6',
            'other'
          ],
          value: '',
          required: true
        },
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: false
        }
      ],
      photos: []
    },
    {
      type: 'ride',
      category: 'client',
      subCategory: 'report-incident',
      code: 'driver-drove-dangerously',
      title: 'dangerousDriverTitle',
      description: 'dangerousDriverText',
      fields: [
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: true
        }
      ],
      photos: []
    },
    {
      type: 'ride',
      category: 'client',
      subCategory: 'driver-was-unprofessional',
      code: 'driver-didnt-match-app-profile',
      title: 'driverNotMatchTitle',
      description: 'driverNotMatchText',
      fields: [
        {
          key: 'vehicleDetails',
          label: 'Vehicle Color, Make and Model',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'driverMatch',
          label: 'Did The Client Mention To The Driver That His Profile Was Different',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: false
        }
      ],
      photos: []
    },
    {
      type: 'ride',
      category: 'client',
      subCategory: 'driver-was-unprofessional',
      code: 'different-issue-with-driver',
      title: 'driverOtherTitle',
      description: 'driverOtherText',
      fields: [
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: true
        }
      ],
      photos: []
    },
    {
      type: 'ride',
      category: 'client',
      subCategory: 'driver-was-unprofessional',
      code: 'driver-made-me-feel-unsafe',
      title: 'driverUnsafeTitle',
      description: 'driverUnsafeText',
      fields: [
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: true
        }
      ],
      photos: []
    },
    {
      type: 'ride',
      category: 'client',
      subCategory: 'driver-was-unprofessional',
      code: 'had-issue-with-my-pickup',
      title: 'pickupIssueTitle',
      description: 'pickupIssueText',
      fields: [
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: true
        }
      ],
      photos: []
    },
    {
      type: 'ride',
      category: 'client',
      subCategory: 'lost-item',
      code: 'lost-item',
      title: 'lostItemTitle',
      description: 'lostItemText',
      fields: [
        {
          key: 'itemDescription',
          label: 'Item Type Description',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'phoneNumber',
          label: 'Phone',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: false
        }
      ],
      photos: []
    },
    {
      type: 'ride',
      category: 'client',
      subCategory: 'would-like-refund',
      code: 'was-overcharged-on-cash-ride',
      title: 'overChargedCashTitle',
      description: 'overChargedCashText',
      fields: [
        {
          key: 'cashExpected',
          label: 'Cash Fare Expected',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'cashAsked',
          label: 'Cash Fare The Driver Asked',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'cashPaid',
          label: 'Cash Fare Paid',
          type: 'text',
          value: '',
          required: true
        },
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: false
        }
      ],
      photos: []
    },
    {
      type: 'ride',
      category: 'client',
      subCategory: 'would-like-refund',
      code: 'driver-took-poor-route',
      title: 'poorRouteTitle',
      description: 'poorRouteText',
      fields: [
        {
          key: 'chooseOneOfOptions',
          label: 'Reason',
          type: 'select',
          options: [
            'poorRouteOption1',
            'poorRouteOption2',
            'poorRouteOption3',
            'poorRouteOption4',
            'other'
          ],
          value: '',
          required: true
        },
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          type: 'textarea',
          value: '',
          required: false
        }
      ],
      photos: []
    }
  ],
  prepareIssueForBackend: async ({
    type,
    category,
    subCategory,
    code,
    rideId,
    fields
  }: {
    type: string
    category: string
    subCategory: string
    code: string
    rideId: string | null
    fields: issueTypes.IssueField[]
  }): Promise<issueTypes.Issue> => {
    const getCurrentLocation = async () => {
      if (type === 'ride') {
        const currentLocation = await appCommunication.getLocation()

        return currentLocation
      } else {
        return []
      }
    }

    const getRideId = async () => {
      if (type === 'ride') {
        return typeCheckerUtils.isTypeString(rideId) ? parseInt(rideId) : null
      } else {
        return null
      }
    }
    const indexOfAdditionalDetails = fields.findIndex((item) => item.key === 'additionalInfo')
    const fieldsWithoutAdditionalDetails = fields.filter((item) => item.key !== 'additionalInfo')

    const currentLocation = await getCurrentLocation()
    const sentRideId = await getRideId()

    return {
      additionalDetails:
        indexOfAdditionalDetails > -1 ? fields[indexOfAdditionalDetails].value : '',
      questions: fieldsWithoutAdditionalDetails.map((item) => item.label),
      answers: fieldsWithoutAdditionalDetails.map((item) => item.value),
      currentLocation: currentLocation,
      rideId: sentRideId,
      category,
      subCategory,
      code,
      type
    }
  }
}
